<!-- 查询月票类型详情列表接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                    "pageNum":1,
                    "pageSize":10,
                    "parkCodeList":[
                        "2KKN6112",
                        "2KKN885S"
                    ],
                    "monthTicketConfigId": 1000001883,
                    "settlementType": 0,
                    "ticketStatus": 1,
                    "ticketCode": "2021042314263041130976",
                    "addTimeStart": "20210401000000",
                    "addTimeEnd": "20210501000000",
                    "isDelete": 0,
                    "needTotal": 0,
                },
            responseCode: {
                "data": {
                    "currCount":1,
                    "recordList":[
                        {
                        "autoSwitchVip":0,
                        "channelInfoList":[
                            {
                            "channelId":7,
                            "entranceType":2,
                            "name":"测试停车场出口",
                            "parkCode":"2KKN6112",
                            "parkName":"智泊云开发测试车场"
                            },
                            {
                            "channelId":2334,
                            "entranceType":1,
                            "name":"测试停车场进口",
                            "parkCode":"2KKN6112",
                            "parkName":"智泊云开发测试车场"
                            }],
                        "dynamicFullLimit":0,
                        "financialParkCode":"2KKN6112",
                        "id":1000001883,
                        "inviteCarSwitcher":0,
                        "inviteCarTotal":0,
                        "isChargeGroupRelated":0,
                        "isDatePrivilege":0,
                        "isDynamicMode":0,
                        "isOnlineOpen":0,
                        "isOnlineRenew":1,
                        "isTimePrivilege":0,
                        "maxSellLimit":0,
                        "maxSellNum":0,
                        "monthTicketContinueDiscountList":[
                            {
                            "amountMoney":18.00,
                            "continuDiscountType":0,
                            "continuMonth":1,
                            "discount":9,
                            "price":20.00
                            },
                            {
                            "amountMoney":48.00,
                            "continuDiscountType":0,
                            "continuMonth":3,
                            "discount":8,
                            "price":20.00
                            },
                            {
                            "amountMoney":70.00,
                            "continuDiscountType":0,
                            "continuMonth":5,
                            "discount":7,
                            "price":20.00
                            },
                            {
                            "amountMoney":84.00,
                            "continuDiscountType":0,
                            "continuMonth":7,
                            "discount":6,
                            "price":20.00
                            }],
                        "openVipFullLimit":0,
                        "parkList":[
                            {
                            "parkCode":"2KKN6112",
                            "parkName":"智泊云开发测试车场"
                            }],
                        "price":20.00,
                        "privilegeTimePeriod":"",
                        "privilegedateList":"",
                        "remark":"",
                        "renewFormerDays":0,
                        "renewMethod":0,
                        "settlementType":0,
                        "supportVirtualCarcode":1,
                        "ticketCode":"2021042314263041130976",
                        "ticketName":"后台可用折扣优惠自然月",
                        "ticketStatus":1,
                        "vipFullOpenModel":0,
                        "vipGroupType":0
                        }],
                    }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询线上月票类型详情列表",
                t_url: this.commonUrls.test + "getMonthTicketConfigDetailList",
                p_url: this.commonUrls.prod + "getMonthTicketConfigDetailList",
                precondition: "无",
                fitSystem: "云停车场，传统停车场（线上开通的月票）",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketConfigId', info2: '否', info3: 'Long', info4: '月票类型ID' },
                        { info1: 'parkCodeList', info2: '是', info3: 'JSONArray', info4: '停车场编码列表（需为同一个运营商的车场）' },
                        { info1: 'settlementType', info2: '否', info3: 'Integer', info4: '结算类型 0时间结算，1储值结算，2储次结算 3储时结算' },
                        { info1: 'ticketStatus', info2: '否', info3: 'Integer', info4: '月票状态：0下架，1上架' },
                        { info1: 'ticketCode', info2: '否', info3: 'String', info4: '月票类型编号' },
                        { info1: 'addTimeStart', info2: '否', info3: 'String', info4: '添加起始时间，yyyyMMddHHmmss' },
                        { info1: 'addTimeEnd', info2: '否', info3: 'String', info4: '添加结束时间，yyyyMMddHHmmss' },
                        { info1: 'isDelete', info2: '否', info3: 'Integer', info4: '是否已删除：0 否，1 是， 默认0' },
                        { info1: 'needTotal', info2: '否', info3: 'Integer', info4: '是否需要总数量：0 否，1 是， 默认0' },
                      { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始' },
                      { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多1000条,默认10' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '月票类型列表' },
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '总记录数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前数' },
                    ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '月票类型ID' },
                        { info1: 'ticketCode', info2: '是', info3: 'String', info4: '月票类型编号' },
                        { info1: 'ticketName', info2: '是', info3: 'String', info4: '月票类型名称' },
                        { info1: 'parkList', info2: '是', info3: 'JSONArray', info4: '适用车场信息' },
                        { info1: 'financialParkCode', info2: '是', info3: 'String', info4: '财务主体车场编号' },
                        { info1: 'channelInfoList', info2: '是', info3: 'JSONArray', info4: '适用车场通道信息' },
                        { info1: 'certifiRuleId', info2: '是', info3: 'Long', info4: '月票凭证ID' },
                        { info1: 'isOnlineOpen', info2: '是', info3: 'Integer', info4: '是否允许移动端开票 0：否 1：是' },
                        { info1: 'isOnlineRenew', info2: '是', info3: 'Integer', info4: '是否允许移动端续费 0：否 1：是' },
                        { info1: 'validTo', info2: '是', info3: 'Integer', info4: '有效期至 yyyyMMddHHmmss' },
                        { info1: 'ticketStatus', info2: '是', info3: 'Integer', info4: '月票状态 0：下架 1：上架' },
                        { info1: 'maxSellLimit', info2: '是', info3: 'Integer', info4: '最大销售数量限制，0无限，1有限' },
                        { info1: 'maxSellNum', info2: '是', info3: 'Integer', info4: '最大销售数量，maxSellLimit=1 有效' },
                        { info1: 'sellNum', info2: '是', info3: 'Integer', info4: '已销售数量' },
                        { info1: 'price', info2: '是', info3: 'Decimal', info4: '单价，单位：元' },
                        { info1: 'renewFormerDays', info2: '是', info3: 'Integer', info4: '允许车主购买该月票时，向前续费相应的天数。0表示不允许向前续费' },
                        { info1: 'renewMethod', info2: '是', info3: 'Integer', info4: '续费方式，对内月票才有，0自然月，1自定义（允许车主自定义选择续费时间，价格按照天数去计算。如月票单价300元，每天则为10元。）默认0' },
                        { info1: 'supportVirtualCarcode', info2: '是', info3: 'Integer', info4: '支持无牌车 0：不支持 1：支持' },
                        { info1: 'inviteCarSwitcher', info2: '是', info3: 'Integer', info4: '访客授权 0：不支持 1：支持' },
                        { info1: 'inviteCarTotal', info2: '否', info3: 'Integer', info4: '允许授权访客车牌数' },
                        { info1: 'isDynamicMode', info2: '是', info3: 'Integer', info4: '是否多位多车（0否，1是）' },
                        { info1: 'autoSwitchVip', info2: '是', info3: 'Integer', info4: '是否自动切换多位多车场内临时车转vip(0否,1是)。' },
                        { info1: 'dynamicFullLimit', info2: '是', info3: 'Integer', info4: '是否多位多车满位，同组在场车无法进入（0否，1是）' },
                        { info1: 'openVipFullLimit', info2: '是', info3: 'Integer', info4: 'vip满位阈值' },
                        { info1: 'vipFullOpenModel', info2: '是', info3: 'Integer', info4: 'VIP满位放行模式 0:系统有空位自动放行，无空位手动放行按VIP计费 1:系统有空位自动放行，无空位手动放行按临时车计费 2:系统无空位自动放行，按临时车计费' },
                        { info1: 'isDatePrivilege', info2: '是', info3: 'Integer', info4: '月票生效的日期，是否区分日期（0不区分，1区分）' },
                        { info1: 'isTimePrivilege', info2: '是', info3: 'Integer', info4: '月票生效的时段，是否区分时间段（0不区分，1区分）' },
                        { info1: 'privilegedateList', info2: '是', info3: 'String', info4: 'VIP有效日期 格式：yyyy-MM-dd，使用‘,’分割。例：“2019-01-01,2019-01-02”' },
                        { info1: 'privilegeTimePeriod', info2: '是', info3: 'Integer', info4: 'VIP有权限时间段，isTimePrivilege=1时必传，格式mm:ss-mm:ss' },
                        { info1: 'isChargeGroupRelated', info2: '是', info3: 'Integer', info4: '是否关联收费组(0否,1是，默认为否)' },
                        { info1: 'chargeGroupCode', info2: '否', info3: 'String', info4: '收费组编号' },
                        { info1: 'monthTicketContinueDiscountList', info2: '否', info3: 'JSONArray', info4: '连续续费优惠' },
                        { info1: 'settlementType', info2: '否', info3: 'Integer', info4: '结算类型 0时间结算，1储值结算，2储次结算 3储时结算' },
                        { info1: 'vipGroupType', info2: '否', info3: 'Integer', info4: 'VIP组类型 0普通vip（包括时间、储值、计次），1访客vip，2黑名单vip，3预定vip，4共享vip' },
                    ]
                },{
                    titleName: 'parkList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        ]
                },{
                    titleName: 'channelInfoList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'channelId', info2: '是', info3: 'Long', info4: '通道ID' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '通道名称' },
                        { info1: 'entranceType', info2: '是', info3: 'Integer', info4: '通道类型 1：进口 2：出口' },
                        ]
                },{
                    titleName: 'monthTicketContinueDiscountList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '连续续费优惠ID' },
                        { info1: 'continuDiscountType', info2: '是', info3: 'Integer', info4: '连续优惠类型,0:折扣优惠,1:金额优惠' },
                        { info1: 'continuMonth', info2: '是', info3: 'Integer', info4: '连续月份' },
                        { info1: 'discount', info2: '是', info3: 'Integer', info4: '折扣 1:1折 2：2折' },
                        { info1: 'price', info2: '是', info3: 'Decimal', info4: '月票单价，单位：元' },
                        { info1: 'amountMoney', info2: '是', info3: 'Decimal', info4: '总金额，单位：元' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getMonthTicketConfigDetailList.vue